"use strict";
exports.__esModule = true;
var IBAN = require("iban");
exports["default"] = (function (input) { return IBAN.isValid(input); });
